import { convert_char, convert_types, utf_code, assist_digit, textarea_default_row, serial_number_digit, } from './Const';
import moment from 'moment';
var NUMBER_DECIMALS = 3; // 小数点以下桁数
var NUMBER_DECIMALS_ROUND_ZERO = 2; // 小数点第3位が0で丸める必要がある場合
/**
 * データ変換
 * @param convert_type 変換タイプ
 * @param value 変換するデータ
 * @return string  変換後のデータ
 */
export var convertData = function (convert_type, value) {
    if (convert_type === convert_types.add_comma) {
        return convertToAddComma(value);
    }
    else if (convert_type === convert_types.change_numeric) {
        return convertToNumeric(value);
    }
    else if (convert_type === convert_types.add_decimal_point) {
        return convertToDecimal(value);
    }
    else if (convert_type === convert_types.change_zenkaku_kana) {
        return convertToFullKana(value);
    }
    else if (convert_type === convert_types.change_hankaku_kana) {
        return convertToHalfKana(value);
    }
    else if (convert_type === convert_types.change_zenkaku) {
        return convertHalfToFull(value);
    }
    else if (convert_type === convert_types.change_account_holder_zenkakuKana) {
        return convertHaltToAccountHolderZenkakuKana(value);
    }
    else if (convert_type === convert_types.serial_number) {
        return serialNumber(value);
    }
    else if (convert_type === convert_types.change_alpha_numeric) {
        return convertAlphaNumeric(value);
    }
    else if (convert_type === convert_types.change_alpha_numeric_symbol) {
        return convertAlphaNumericSymbol(value);
    }
    else if (convert_type === convert_types.change_hyphen_to_slash) {
        return convertHyphenToSlash(value);
    }
    else if (convert_type === convert_types.change_upper_alpha_numeric) {
        return convertUpperCaseAlphaNumeric(value);
    }
    else if (convert_type === convert_types.change_upper_alpha_numeric_symbol) {
        return convertUpperCaseAlphaNumericSymbol(value);
    }
    else {
        return value;
    }
};
/**
 * 数値カンマ付与
 * @param original 変換するデータ
 * @return string  変換後のデータ
 */
var convertToAddComma = function (original) {
    var result = original;
    // 数値に変換
    result = convertToNumeric(result);
    if (result !== '') {
        // 3桁区切り
        result = new Intl.NumberFormat().format(Number(result));
    }
    return result;
};
/**
 * 数値に変換
 * @param original 変換するデータ
 * @return string  変換後のデータ
 */
var convertToNumeric = function (original) {
    var result = original;
    // 全角数字→半角数字
    result = convertFullNumericToHalfNumeric(result);
    // 数字(0～9)以外を除去して
    result = result.replace(/[^\d]/g, '');
    return result;
};
/**
 * 全角数字→半角数字変換
 * @param original 変換するデータ
 * @return string  変換後のデータ
 */
export var convertFullNumericToHalfNumeric = function (original) {
    var result = '';
    for (var i = 0; i < original.length; i++) {
        var code_original = original.charCodeAt(i);
        if (code_original >= utf_code.zenkaku_numeric_start &&
            code_original <= utf_code.zenkaku_numeric_end) {
            result += String.fromCharCode(code_original - utf_code.zenkaku_numeric_convert);
        }
        else {
            result += original.charAt(i);
        }
    }
    return result;
};
/**
 * 全角ドット→半角ドット変換
 * @param original 変換するデータ
 * @return string  変換後のデータ
 */
var convertFullDotToHalfDot = function (original) {
    return original.replace(/．/g, '.');
};
/**
 * 小数書式変換
 * @param original 変換するデータ
 * @return string  変換後のデータ
 */
var convertToDecimal = function (original) {
    var result = original;
    // 全角数字,小数点→半角数字,小数点
    result = convertFullNumericToHalfNumeric(result);
    result = convertFullDotToHalfDot(result);
    // 数字(0～9,ドット)以外を除去
    result = result.replace(/[^\d^\.]/g, '');
    if (result !== '' && !isNaN(parseInt(result))) {
        // 四捨五入
        result = (Math.round(Number(result) * 1000) / 1000).toFixed(NUMBER_DECIMALS);
    }
    // 小数点第3位が0の場合は丸める
    var decimal_place = result.match(/[.]([\d]+)$/);
    // 小数点が第3位まである、かつ末尾桁（第3位）が0である場合は、第3位を丸める
    if (decimal_place !== null && decimal_place[1].length === 3 && decimal_place[1].match(/0$/)) {
        result = Number(result).toFixed(NUMBER_DECIMALS_ROUND_ZERO);
    }
    return result;
};
/**
 * 全角カナ変換
 * @param original 変換するデータ
 * @return string  変換後のデータ
 */
var convertToFullKana = function (original) {
    return convertHalfKanaToFullKana(convertHiraganaToFullKana(original));
};
/**
 * 全角ひらがな→全角カナ変換
 * @param original 変換するデータ
 * @return string  変換後のデータ
 */
var convertHiraganaToFullKana = function (original) {
    var result = '';
    for (var i = 0; i < original.length; i++) {
        var code_original = original.charCodeAt(i);
        if (code_original >= utf_code.zenkaku_hiragana_start &&
            code_original <= utf_code.zenkaku_hiragana_end) {
            // 全角ひらがな
            result += String.fromCharCode(code_original + utf_code.zenkaku_hiragana_convert);
        }
        else {
            result += original.charAt(i);
        }
    }
    return result;
};
/**
 * 半角ｶﾅ→全角カナ変換
 * @param original 変換するデータ
 * @return string  変換後のデータ
 */
var convertHalfKanaToFullKana = function (original) {
    var result = '';
    var len = original.length;
    var reg_exp_base_dakuon = new RegExp('[' + convert_char.hankaku_kana_dakuon_base + ']');
    var reg_exp_base_handakuon = new RegExp('[' + convert_char.hankaku_kana_handakuon_base + ']');
    for (var i = 0; i < len; i++) {
        var c = original.charAt(i);
        var code_original = c.charCodeAt(0);
        if (code_original >= 0xff61 && code_original <= 0xff9f) {
            // 半角ｶﾅ
            var dakuon_or_handakuon = false;
            if (c.match(reg_exp_base_dakuon) != null) {
                if (i < len - 1) {
                    // 次の文字
                    var code_next = original.charCodeAt(i + 1);
                    if (code_next == utf_code.hankaku_dakuten) {
                        // 濁点あり
                        dakuon_or_handakuon = true;
                        i++;
                        var index = convert_char.hankaku_kana_dakuon_base.indexOf(c);
                        result += convert_char.zenkaku_kana_dakuon.charAt(index);
                    }
                }
            }
            if (!dakuon_or_handakuon) {
                if (c.match(reg_exp_base_handakuon) != null) {
                    if (i < len - 1) {
                        // 次の文字
                        var code_next = original.charCodeAt(i + 1);
                        if (code_next == utf_code.hankaku_handakuten) {
                            // 半濁点あり
                            dakuon_or_handakuon = true;
                            i++;
                            var index = convert_char.hankaku_kana_handakuon_base.indexOf(c);
                            result += convert_char.zenkaku_kana_handakuon.charAt(index);
                        }
                    }
                }
            }
            if (!dakuon_or_handakuon) {
                var index = convert_char.hankaku_kana.indexOf(c);
                result += convert_char.zenkaku_kana.charAt(index);
            }
        }
        else if (c.match(convert_char.hankaku_space)) {
            //半角スペースの場合全角に変換
            result += convert_char.zenkaku_space;
        }
        else {
            result += c;
        }
    }
    return result;
};
/**
 * 半角ｶﾅ変換
 * @param original 変換するデータ
 * @return string  変換後のデータ
 */
var convertToHalfKana = function (original) {
    return convertFullKanaToHalfKana(convertHiraganaToHalfKana(original));
};
/**
 * 全角カナ→半角ｶﾅ変換
 * @param original 変換するデータ
 * @return string  変換後のデータ
 */
var convertFullKanaToHalfKana = function (original) {
    var result = original;
    // 濁点、半濁点なしの文字を置換
    for (var i = 0; i < convert_char.zenkaku_kana.length; i++) {
        var reg_exp = new RegExp(convert_char.zenkaku_kana.charAt(i), 'g');
        result = result.replace(reg_exp, convert_char.hankaku_kana.charAt(i));
    }
    // 濁点ありの文字を置換
    for (var i = 0; i < convert_char.zenkaku_kana_dakuon.length; i++) {
        var reg_exp = new RegExp(convert_char.zenkaku_kana_dakuon.charAt(i), 'g');
        result = result.replace(reg_exp, convert_char.hankaku_kana_dakuon_base.charAt(i) + convert_char.hankaku_kana_dakuten);
    }
    // 半濁点ありの文字を置換
    for (var i = 0; i < convert_char.zenkaku_kana_handakuon.length; i++) {
        var reg_exp = new RegExp(convert_char.zenkaku_kana_handakuon.charAt(i), 'g');
        result = result.replace(reg_exp, convert_char.hankaku_kana_handakuon_base.charAt(i) + convert_char.hankaku_kana_handakuten);
    }
    return result;
};
/**
 * 全角ひらがな→半角ｶﾅ変換
 * @param original 変換するデータ
 * @return string  変換後のデータ
 */
var convertHiraganaToHalfKana = function (original) {
    var result = original;
    // 濁点、半濁点なしの文字を置換
    for (var i = 0; i < convert_char.zenkaku_hiragana.length; i++) {
        var reg_exp = new RegExp(convert_char.zenkaku_hiragana.charAt(i), 'g');
        result = result.replace(reg_exp, convert_char.hankaku_kana.charAt(i));
    }
    // 濁点ありの文字を置換
    for (var i = 0; i < convert_char.zenkaku_hiragana_dakuon.length; i++) {
        var reg_exp = new RegExp(convert_char.zenkaku_hiragana_dakuon.charAt(i), 'g');
        result = result.replace(reg_exp, convert_char.hankaku_kana_dakuon_base.charAt(i) + convert_char.hankaku_kana_dakuten);
    }
    // 半濁点ありの文字を置換
    for (var i = 0; i < convert_char.zenkaku_hiragana_handakuon.length; i++) {
        var reg_exp = new RegExp(convert_char.zenkaku_hiragana_handakuon.charAt(i), 'g');
        result = result.replace(reg_exp, convert_char.hankaku_kana_handakuon_base.charAt(i) + convert_char.hankaku_kana_handakuten);
    }
    return result;
};
/**
 * 改行コードをエスケープされていない形に変換する。
 * 数値型は文字列に変換して返却する
 *
 * @param original 変換するデータ
 * @return string  変換後のデータ
 */
export var convertLine = function (original) {
    // 数値型の場合はstring化して返却
    if (typeof original === 'number') {
        return String(original);
    }
    else if (typeof original !== 'string') {
        return original;
    }
    //改行コードがエスケープされている場合はエスケープなしに置換
    return original.match(/\\n/g) !== null ? original.replace(/\\n/g, '\n') : original;
};
/**
 * 10文字以下の文字列を0埋めの10桁になるように整形する
 * @param value 入力値
 * @return string 整形後のデータ
 */
export var inputAssistDigit = function (value) {
    if (value !== undefined && value !== null && value !== '') {
        //10桁以下の場合は0で桁を埋める。
        if (value.length < 10) {
            var resultValue = assist_digit.slice(value.length) + value;
            return resultValue;
        }
    }
    //入力値が未定義、空文字、10文字以上の場合は成形せずに返却する。
    return value;
};
/**
 * 半角→全角変換
 * @param original 入力値
 * @return string 変換後の文字列
 */
export var convertHalfToFull = function (original) {
    // 半角カタカナを全角カタカナに変換する
    var new_str = convertHalfKanaToFullKana(original);
    // 半角英数字と記号を全角に変換する
    return new_str.replace(/[!-~]/g, function (str) { return String.fromCharCode(str.charCodeAt(0) + 0xfee0); });
};
/**
 * 半角→口座名義(カナ)の使用文字
 * @param original 入力値
 * @return string 変換後の文字列
 */
export var convertHaltToAccountHolderZenkakuKana = function (original) {
    // 半角英数を全角英数に変換する
    var new_str = convertHalfAlphaNumeralToFullAlphaNumeral(convertHalfNumeralToFullNumeral(convertFullKanaToHaltToAccountHolderFullKana(convertHiraganaToFullKana(original))));
    // 記号を全角に変換する
    return new_str.replace(/[!-~]/g, function (str) {
        return String.fromCharCode(str.charCodeAt(0) + utf_code.zenkaku_numeric_convert);
    });
};
/**
 * 全角カナ→口座名義(カナ)の使用文字変換
 * @param original 変換するデータ
 * @return string  変換後のデータ
 */
export var convertFullKanaToHaltToAccountHolderFullKana = function (original) {
    //半角カナ,半角の記号(バックスラッシュ)を置換
    return convertToFullKana(original).replace(convert_char.hankaku_backslash, convert_char.zenkaku_backslash);
};
/**
 * 半角数字→全角数字変換
 * @param original 変換するデータ
 * @return string  変換後のデータ
 */
var convertHalfNumeralToFullNumeral = function (original) {
    var result = original;
    // 半角数字を全角数字に置換
    for (var i = 0; i < convert_char.hankaku_numeric_base.length; i++) {
        var reg_exp = new RegExp(convert_char.hankaku_numeric_base.charAt(i), 'g');
        result = result.replace(reg_exp, convert_char.zenkaku_numeric_base.charAt(i));
    }
    return result;
};
/**
 * 半角英字→全角英字変換
 * @param original 変換するデータ
 * @return string  変換後のデータ
 */
var convertHalfAlphaNumeralToFullAlphaNumeral = function (original) {
    var result = original;
    // 半角英字を全角英字に置換
    for (var i = 0; i < convert_char.hankaku_alphabet_base.length; i++) {
        var reg_exp = new RegExp(convert_char.hankaku_alphabet_base.charAt(i), 'g');
        result = result.replace(reg_exp, convert_char.zenkaku_alphabet_base.charAt(i));
    }
    return result;
};
/**
 * タイプが一致する場合、入力値からカンマを除去する
 * @param original 入力値
 * @param type 変換タイプ
 */
export var removeComma = function (original, type) {
    if (type === convert_types.add_comma) {
        return original.replace(/,/g, '');
    }
    else {
        return original;
    }
};
/*
 * 文字列から行数を取得する。
 * @return number
 */
export var calcRow = function (text) {
    var rows = text !== null ? text.split('\n') : '';
    if (rows.length > 1) {
        return rows.length + 1;
    }
    else {
        return textarea_default_row;
    }
};
/**
 * 口座番号の０埋め
 * @param text 変換するデータ
 * @return string  変換後のデータ
 */
var serialNumber = function (text) {
    //半角英数大文字変換
    var result = convertUpperCaseAlphaNumeric(text);
    //数値が6桁以下の場合に6桁になるよう0で埋める
    result = serialNumberDigit(result);
    return result;
};
/**
 * 入力テキストを半角大文字英数に変換
 *
 * @param {string} text 変換するデータ
 * @return {string} 変換後のデータ
 */
var convertUpperCaseAlphaNumeric = function (text) {
    if (typeof text !== 'string' || text == null) {
        return '';
    }
    var result = text.replace(/[^0-9a-zａ-ｚ０-９]/gi, '');
    //全角英数→半角英数変換
    result = convertFullWidthCharacterToHalfWidthCharacter(result);
    //英小文字→英大文字変換
    result = convertUppercaseLetterToLowercase(result);
    return result;
};
/**
 * 全角英数から半角英数変換
 * @param text 変換するデータ
 * @return string  変換後のデータ
 */
var convertFullWidthCharacterToHalfWidthCharacter = function (text) {
    if (typeof text !== 'string' || text == null) {
        return '';
    }
    return text.replace(/[ａ-ｚ０-９]/gi, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - utf_code.zenkaku_numeric_convert);
    });
};
/**
 * 英小文字から英大文字変換
 * @param text 変換するデータ
 * @return string  変換後のデータ
 */
var convertUppercaseLetterToLowercase = function (text) {
    return text.toUpperCase();
};
/**
 * 数値が6桁以下の場合に6桁になるよう0で埋める
 * @param text 変換するデータ
 * @returns string  変換後のデータ
 */
var serialNumberDigit = function (text) {
    if (text !== undefined && text !== null && text !== '') {
        //6桁以下の場合は0で桁を埋める。
        if (text.length < 6) {
            var resultValue = serial_number_digit.slice(text.length) + text;
            return resultValue;
        }
    }
    //入力値が未定義、空文字、6文字以上の場合は成形せずに返却する。
    return text;
};
/**
 * 半角英数に変換
 * @param text 変換するデータ
 * @return string  変換後のデータ
 */
export var convertAlphaNumeric = function (text) {
    if (typeof text !== 'string' || text == null) {
        return '';
    }
    var result = text.replace(/[^0-9a-zａ-ｚ０-９]/gi, '');
    //全角英数→半角英数変換
    result = convertFullWidthCharacterToHalfWidthCharacter(result);
    return result;
};
/**
 * 半角英数記号に変換(全角記号は削除される)
 * @param text 変換するデータ
 * @return string  変換後のデータ
 */
export var convertAlphaNumericSymbol = function (text) {
    if (typeof text !== 'string' || text == null) {
        return '';
    }
    var result = text.replace(/[^0-9a-zａ-ｚ０-９!-~]/gi, '');
    //全角英数→半角英数変換
    result = convertFullWidthCharacterToHalfWidthCharacter(result);
    return result;
};
/**
 * 半角大文字英数記号に変換(全角記号は削除される)
 *
 * @param {string} text 変換するデータ
 * @return {string} 変換後のデータ
 */
export var convertUpperCaseAlphaNumericSymbol = function (text) {
    if (typeof text !== 'string' || text == null) {
        return '';
    }
    // 半角英数記号変換
    var result = convertAlphaNumericSymbol(text);
    //英小文字→英大文字変換
    result = convertUppercaseLetterToLowercase(result);
    return result;
};
/**
 * yyyy/mm/dd の形式に変換する
 * @param text 変換するデータ
 * @return string  変換後のデータ
 */
var convertHyphenToSlash = function (text) {
    var is_result = moment(text, 'YYYY-MM-DD').isValid();
    if (is_result) {
        var target = moment(text);
        return target.format('YYYY/MM/DD');
    }
    else {
        return '';
    }
};
